import { bold, num } from "../../utils/xlsx";
import { cellRight, money } from "./common";

// Two-sided (T-format) statements, as Tally prints the P&L and Balance Sheet.
// A statement row is { label, amount, level, strong }: level 0 = group / total line, deeper levels are indented under it.

/** A group heading followed by its ledgers. */
export const blockRows = (block, label) => {
  if (!block) return [];
  return [
    { label: label || block.label, amount: block.total, level: 0 },
    ...(block.lines || []).map((line) => ({ label: line.name, amount: line.amount, level: 1 })),
  ];
};

export const StatementSide = ({ title, rows, totalLabel = "Total", total }) => (
  <div className="table-wrapper" style={{ flex: "1 1 380px", minWidth: 0, marginTop: 0 }}>
    <table>
      <thead>
        <tr>
          <th style={{ textAlign: "left" }}>{title}</th>
          <th style={cellRight}>Amount (₹)</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={2} style={{ color: "var(--color-text-faint)" }}>
              Nothing to show
            </td>
          </tr>
        ) : (
          rows.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  textAlign: "left",
                  paddingLeft: row.level ? `${row.level * 20 + 8}px` : undefined,
                  fontWeight: row.level ? 400 : 600,
                  color: row.level ? "var(--color-text-muted)" : undefined,
                  ...(row.strong ? { fontWeight: 700 } : {}),
                }}
              >
                {row.label}
              </td>
              <td style={{ ...cellRight, fontWeight: row.level ? 400 : 600, ...(row.strong ? { fontWeight: 700 } : {}) }}>
                {row.amount === null || row.amount === undefined ? "" : money(row.amount)}
              </td>
            </tr>
          ))
        )}
      </tbody>
      {total !== undefined ? (
        <tfoot>
          <tr>
            <td style={{ textAlign: "left", fontWeight: 700 }}>{totalLabel}</td>
            <td style={{ ...cellRight, fontWeight: 700 }}>{money(total)}</td>
          </tr>
        </tfoot>
      ) : null}
    </table>
  </div>
);

export const StatementSides = ({ children }) => (
  <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "flex-start", marginTop: "16px" }}>{children}</div>
);

/** Excel rows for two sides laid out next to each other: [left label, left amount, (gap), right label, right amount]. */
export const sideBySideRows = (left, right) => {
  const cell = (row) => {
    if (!row) return ["", ""];
    const label = `${"    ".repeat(row.level || 0)}${row.label}`;
    const emphasised = !row.level || row.strong;
    return [emphasised ? bold(label) : label, emphasised ? bold(num(row.amount)) : num(row.amount)];
  };
  const out = [[bold(left.title), bold("Amount"), "", bold(right.title), bold("Amount")]];
  const length = Math.max(left.rows.length, right.rows.length);
  for (let i = 0; i < length; i++) out.push([...cell(left.rows[i]), "", ...cell(right.rows[i])]);
  out.push([bold(left.totalLabel || "Total"), bold(num(left.total)), "", bold(right.totalLabel || "Total"), bold(num(right.total))]);
  return out;
};
